import {Layout} from 'antd';
import * as React from 'react';
import {connect} from 'react-redux';
import AppConfig from '../../config/AppConfig';
import themes from '../../config/themes';
import AppRedux from '../../redux/app/appRedux';
import TopbarWrapper from './topbar.style';
import TopbarUser from './topbarUser';

const {Header} = Layout;
const customizedTheme = themes[AppConfig.themeConfig.theme];


class Topbar extends React.Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: false,
            openDrawer: true,
            selectedItem: ''
        };
    }

    public componentWillReceiveProps(newProps) {
        const newState = {
            collapsed: newProps.collapsed,
            openDrawer: newProps.openDrawer
        };
        this.setState(newState);
    }

    public render() {
        const collapsed = this.state.collapsed && !this.state.openDrawer;
        return (
            <TopbarWrapper>
                <Header
                    style={{
                        background: customizedTheme.backgroundColor,
                        position: 'fixed',
                        width: '100%',
                        height: 70
                    }}
                    className={collapsed
                        ? 'isomorphicTopbar collapsed'
                        : 'isomorphicTopbar'}>
                    <div className='isoLeft'>
                        <button
                            className={collapsed
                                ? 'triggerBtn menuCollapsed'
                                : 'triggerBtn menuOpen'}
                            style={{
                                color: customizedTheme.textColor
                            }}
                            onClick={this.props.collapseChange.bind(this)}/>
                    </div>

                    <ul className='isoRight'>
                        <li onClick={() => this.setState({selectedItem: 'user'})} className='isoUser'>
                            <TopbarUser/>
                        </li>
                    </ul>
                </Header>
            </TopbarWrapper>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        collapsed: state.App.collapsed,
        openDrawer: state.App.openDrawer
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        collapseChange: () => dispatch(AppRedux.collapseChange())
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Topbar);



// WEBPACK FOOTER //
// ./src/containers/Topbar/Topbar.tsx